const CommissionValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

export type Commission = (typeof CommissionValues)[number] & { __brand: 'Commission' };

export const COMMISSION_VALUES: Commission[] = [...CommissionValues] as Commission[];

/**
 * Function to validate if a given number is a valid commission.
 *
 * @param value - The number to validate.
 * @returns True if the number is a valid commission, false otherwise.
 */
export function isCommission(value: number): value is Commission {
  return COMMISSION_VALUES.includes(value as Commission);
}
